import * as breakpoints from '../../json/breakpoints.json';
import Cookies from 'js-cookie';

export const themeSwitch = () => {
    const str = breakpoints.lg;
    const res = str.slice(0, 4);

    let scrollTop = 0;
    const breakPointMobile = res;

    let secondLevel = false;

    const html = document.querySelector('html');
    const body = document.querySelector('body');
    const subMenu = document.querySelector('.sub-menu'); // sub-menu is the top container for the sitemap navigation layover
    const closeOverlayButton = document.querySelector(
        '[data-lumc-id="menu-toggle-close"]'
    );
    const showNavigationOverlayButton = document.querySelector(
        '[data-lumc-id="menu-toggle-open"]'
    );
    const searchOverlay = document.querySelector('.search-overlay-block');

    const pageMain = document.querySelector('.page-main');
    const footer = document.querySelector('footer');

    const sitemapNav = document.querySelector('#sitemap-nav');

    const menuRight = document.getElementById('menu-right');

    const menuItems = document.querySelectorAll('.sub-menu__level01-link');
    const mobileMenuSecondary = document.querySelector(
        '.sub-menu__secondary-nav'
    );
    const mobileBackButton = document.querySelector('.sub-menu__back-button');

    const menuContent = document.querySelectorAll('.sub-menu__level02-nav');

    const headerLanguageSwitch = document.querySelector('#language-switch');

    const contrastSwitch = document.querySelector('#contrast-switch');

    const openSearchOverlayButton = document.querySelector(
        '.search-icon-holder'
    );
    const headerLoginDesktop = document.querySelector('.login-btn');
    const headerLoginMobile = document.querySelector('.login-btn-mobile');

    const hiddenAttributeForMain = document.createAttribute('hidden');
    const hiddenAttributeForSearch = document.createAttribute('hidden');
    const hiddenAttributeForFooter = document.createAttribute('hidden');

    const overlayMenuItemsHide = () => {
        headerLanguageSwitch.classList.add('header-hidden-item');
        headerLoginDesktop.classList.add('header-hidden-item');
        headerLoginMobile.classList.add('header-hidden-item');

        pageMain.setAttributeNode(hiddenAttributeForMain);
        footer.setAttributeNode(hiddenAttributeForFooter);

        openSearchOverlayButton.classList.add('header-hidden-item');
    };

    const overlayMenuItemsShow = () => {
        headerLanguageSwitch.classList.remove('header-hidden-item');
        headerLoginDesktop.classList.remove('header-hidden-item');
        headerLoginMobile.classList.remove('header-hidden-item');
        openSearchOverlayButton.classList.remove('header-hidden-item');
    };

    const subMenuReset = () => {
        for (let i = 0; i < menuItems.length; i += 1) {
            menuContent[i].classList.remove('sub-navigation-mobile-show');
            menuItems[i].classList.add('sub-menu__level01-link--show');
            menuItems[i].classList.remove('sub-menu__level01-link--active');
        }
        mobileBackButton.classList.add('sub-menu__back-button--hidden');
        mobileMenuSecondary.classList.remove('sub-menu__secondary-nav--hidden');
    };

    // for (let i = 0; i < menuContent.length; i += 1) {
    //     const j = i + 1;
    //     const margin = 100;
    //     const calc = margin * j;
    //     menuContent[i].style.marginTop = `${calc}px`;
    // }

    $.urlParam = (name) => {
        const results = new RegExp(`[?&]${name}=([^&#]*)`).exec(
            window.location.search
        );

        return results !== null ? results[1] || 0 : false;
    };

    if (window.location.search && $.urlParam('query')) {
        overlayMenuItemsHide();
    }

    if (closeOverlayButton) {
        closeOverlayButton.addEventListener('click', () => {
            if (secondLevel === false) {
                body.classList.remove('dark-theme');
                body.classList.add('light-theme');
                subMenu.classList.add('sub-menu--hidden');

                pageMain.removeAttribute('hidden');

                searchOverlay.classList.add('hidden-overlay-input');
                overlayMenuItemsShow();
                html.dataset.scrolldir = 'up';
                window.scrollTo(0, scrollTop);
            } else if (secondLevel === true) {
                searchOverlay.classList.add('hidden-overlay-input');
                // searchOverlay.addAttribute('hidden');
                overlayMenuItemsShow();
                secondLevel = false;
                html.dataset.scrolldir = 'up';
                window.scrollTo(0, scrollTop);
            }
        });
    }

    if (showNavigationOverlayButton) {
        showNavigationOverlayButton.addEventListener('click', () => {
            scrollTop =
                window.pageYOffset !== undefined
                    ? window.pageYOffset
                    : (
                          document.documentElement ||
                          document.body.parentNode ||
                          document.body
                      ).scrollTop;
            body.classList.remove('light-theme');
            body.classList.add('dark-theme');
            // subMenu.classList.add("sub-menu-displayed");
            subMenu.classList.remove('sub-menu--hidden');
            html.dataset.scrolldir = 'up';
            // window.scrollTo(0, 0);
            html.style.top = `-${scrollTop}px`;

            sitemapNav.removeAttribute('hidden');
            showNavigationOverlayButton.setAttribute('aria-expanded', 'true');
            closeOverlayButton.setAttribute('aria-expanded', 'true');

            pageMain.setAttributeNode(hiddenAttributeForMain);
            searchOverlay.setAttributeNode(hiddenAttributeForSearch);
            footer.setAttributeNode(hiddenAttributeForFooter);

            $('html :focusable').attr('tabindex', -1);
            $('header :focusable').attr('tabindex', 0);
            $('.sub-menu :focusable').attr('tabindex', 0);

            // subMenuReset();     // If this is activated, it is not possible to set the active menu from the back-end code.
        });
    }

    if (openSearchOverlayButton) {
        openSearchOverlayButton.addEventListener('click', () => {
            scrollTop =
                window.pageYOffset !== undefined
                    ? window.pageYOffset
                    : (
                          document.documentElement ||
                          document.body.parentNode ||
                          document.body
                      ).scrollTop;
            if (!subMenu.classList.contains('sub-menu--hidden')) {
                secondLevel = true;
                // console.log('second level true');
            } else {
                secondLevel = false;
                // console.log('second level false');
            }

            searchOverlay.classList.remove('hidden-overlay-input');
            searchOverlay.removeAttribute('hidden');
            showNavigationOverlayButton.setAttribute('aria-expanded', 'false');
            openSearchOverlayButton.setAttribute('aria-expanded', 'true');

            closeOverlayButton.setAttribute(
                'aria-controls',
                'search-overlay-block'
            );
            closeOverlayButton.setAttribute('aria-expanded', 'true');

            $('html :focusable').attr('tabindex', -1);
            $('.pancake-close').attr('tabindex', 0);
            $('.search-overlay-block :focusable').attr('tabindex', 0);

            body.classList.remove('light-theme');
            body.classList.add('dark-theme');
            overlayMenuItemsHide();
            document.querySelector('.overlay-input-field').focus();
        });
    }

    for (let j = 0; j < menuItems.length; j += 1) {
        const amount = j;

        // ToDO: @John - hier staat een toggle...
        const shouldRepositionAfterClick = false;

        const setSubMenuMarginTop = (index) => {
            if (shouldRepositionAfterClick) {
                // eslint-disable-next-line no-param-reassign
                menuContent[index].style.marginTop = `${
                    menuItems[index].offsetTop + menuItems[index].clientHeight
                }px`;
                const scrollArea = document.querySelector('.sub-menu');
                if (scrollArea) {
                    scrollArea.scrollTo(0, 0);
                }
            }
        };

        menuItems[j].addEventListener('click', () => {
            if (document.documentElement.clientWidth < breakPointMobile) {
                menuContent[amount].classList.add('sub-navigation-mobile-show');
            } else {
                menuContent.forEach((item) => {
                    item.classList.remove('sub-menu__level02-nav--active');
                });
                menuContent[amount].classList.add(
                    'sub-menu__level02-nav--active'
                );
                setSubMenuMarginTop(amount);
            }
        });

        if (amount === 0) {
            setTimeout(() => {
                setSubMenuMarginTop(0);
            }, 0);
        }
    }

    menuItems.forEach((menuItem) => {
        menuItem.addEventListener('click', () => {
            window.scrollTo(0, 0);
            html.dataset.scrolldir = 'up';
            for (let i = 0; i < menuItems.length; i += 1) {
                menuItems[i].classList.remove('sub-menu__level01-link--active');
                if (document.documentElement.clientWidth < breakPointMobile) {
                    menuItems[i].classList.remove(
                        'sub-menu__level01-link--show'
                    );
                }
            }
            menuItem.classList.add('sub-menu__level01-link--active');
            menuItem.classList.add('sub-menu__level01-link--show');

            menuRight.scrollIntoView();

            if (document.documentElement.clientWidth < breakPointMobile) {
                mobileMenuSecondary.classList.add(
                    'sub-menu__secondary-nav--hidden'
                );
                mobileBackButton.classList.remove(
                    'sub-menu__back-button--hidden'
                );
            }
        });
    });

    if (mobileBackButton) {
        mobileBackButton.addEventListener('click', () => {
            subMenuReset();
        });
    }

    const setContrast = (hasContrast) => {
        if (hasContrast == 'true') {
            // Get HTML head element
            let head = document.getElementsByTagName('HEAD')[0];

            // Create new link Element
            let link = document.createElement('link');

            link.id = 'contrast-css';

            // set the attributes for link element
            link.rel = 'stylesheet';

            link.type = 'text/css';

            link.href = '/static/lumc/css/contrast.css';

            // Append link element to HTML head
            head.appendChild(link);
            Cookies.set('contrastCookie', 'true', { expires: 7, path: '/' });
        } else {
            var sheet = document.getElementById('contrast-css');
            if (sheet) {
                sheet.disabled = true;
                sheet.parentNode.removeChild(sheet);
            }

            Cookies.set('contrastCookie', 'false', { expires: 7, path: '/' });
        }
    };

    if (contrastSwitch) {
        let hasContrast = Cookies.get('contrastCookie');

        setContrast(hasContrast);

        contrastSwitch.addEventListener('click', () => {
            let contrastToggle = Cookies.get('contrastCookie');

            if (contrastToggle == 'true') {
                contrastToggle = 'false';
            } else {
                contrastToggle = 'true';
            }

            setContrast(contrastToggle);
        });
    }
};
